export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/vector_art.a495e10.png";